import { defineMessages } from "react-intl";

export const posts = defineMessages({
  addBlock: {
    id: "component.posts.addBlock",
    defaultMessage: "Aggiungi blocco",
  },
  addGroup: {
    id: "component.posts.addGroup",
    defaultMessage: "Aggiungi gruppo",
  },
  addGroupInfo: {
    id: "component.posts.addGroupInfo",
    defaultMessage:
      "Per migliorare la leggibilità i contenuti di un post sono suddivisi in diverse sezioni detti gruppi",
  },
  addPost: {
    id: "component.posts.addPost",
    defaultMessage: "Aggiungi post",
  },
});
